import { Component, OnInit, Input } from '@angular/core';
import { NewsCarouselContainerService } from './news-carousel-container.service';

@Component({
  selector: 'fcp-news-carousel-container',
  template: `
    <fcp-news-carousel [data]="data"></fcp-news-carousel>
  `
})
export class NewsCarouselContainerComponent implements OnInit {
  @Input() private component: any;
  public data;
  constructor(
    private newsCarouselContainerService: NewsCarouselContainerService
  ) {}

  ngOnInit() {
    this.data = this.newsCarouselContainerService.buildResponseNewsCarousel(
      this.component
    );
  }
}
